import { useState, useEffect } from "react";

const ProjectCard = ({ project, hoverColor, onViewDetails }) => {
  return (
    <div
      className={`group bg-card-bg/50 border border-white/10 rounded-[2rem] overflow-hidden hover:border-${hoverColor}/30 transition-all duration-300 hover:-translate-y-1 flex flex-col`}
    >
      <div className="relative h-48 overflow-hidden">
        <div
          className={`absolute inset-0 bg-${hoverColor}/10 group-hover:bg-transparent transition-colors duration-300 z-10`}
        ></div>
        <img
          alt={project.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          src={project.image}
        />
      </div>
      <div className="p-6 flex flex-col flex-1">
        <div className="mb-4">
          <h3 className="text-xl font-bold font-display text-white mb-2">
            {project.name}
          </h3>
          <p className="text-gray-400 text-sm line-clamp-2">
            {project.description}
          </p>
        </div>
        <div className="mt-auto pt-4 border-t border-white/5">
          <button
            onClick={() => onViewDetails(project)}
            className={`w-full py-3 px-4 rounded-xl bg-white/5 hover:bg-${hoverColor} hover:text-white border border-white/10 hover:border-${hoverColor} text-gray-300 text-sm font-medium transition-all duration-300 flex items-center justify-center gap-2 group/btn`}
          >
            <span>View More / Details</span>
            <span className="material-symbols-outlined text-[18px] group-hover/btn:translate-x-1 transition-transform">
              arrow_forward
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

const ProjectsSection = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  const projects = [
    {
      id: 1,
      name: "Habit-Tracker",
      description:
        "Helping you build better habits with the right tools and support. Create, track, and manage daily habits to build streaks and boost productivity.",
      image: "https://i.ibb.co.com/ksjXp4L3/Gemini-Generated-habit.png",
      hoverColor: "primary",
      techStack: [
        "React",
        "React Router",
        "Node.js",
        "MongoDB",
        "Express.js",
        "Tailwind CSS",
        "Framer Motion",
      ],
      briefDescription:
        "A comprehensive habit tracking application that helps users build and maintain positive habits through streak tracking, progress visualization, and motivational features. The app includes user authentication, habit categorization, and detailed analytics.",
      liveLink: "https://habit-tracket.netlify.app",
      githubLink:
        "https://github.com/Sakib8git/Project1-habit-tracker-clint.git",
      challenges: [
        "Implementing real-time streak calculations and maintaining accuracy across different time zones",
        "Creating an intuitive UI that motivates users without overwhelming them",
        "Optimizing database queries for habit statistics and progress tracking",
      ],
      improvements: [
        "Add social features to share progress with friends",
        "Implement habit recommendations based on user behavior",
        "Create mobile app version with offline capabilities",
        "Add gamification elements like badges and achievements",
      ],
    },
    {
      id: 2,
      name: "FreshCart",
      description:
        "A modern, Next.js-powered e-commerce platform for fresh groceries. Features a clean UI, secure Firebase authentication, and seamless cart management.",
      image:
        "https://i.ibb.co.com/fVPv4JF2/Gemini-Generated-Image-jdui4wjdui4wjdui-1.png",
      hoverColor: "green",
      techStack: [
        "Next.js 16",
        "Tailwind CSS",
        "Firebase Auth",
        "ShadCN UI",
        "React Context API",
        "React Hook Form",
        "Lucide Icons",
      ],
      briefDescription:
        "FreshCart is a comprehensive e-commerce web application designed for selling fresh grocery items like fruits, vegetables, and dairy. Leveraging the power of Next.js 16 App Router, it offers a fast, SEO-friendly browsing experience. The application features robust user authentication via Firebase, a dynamic shopping cart managed by React Context, and a polished user interface built with ShadCN and Tailwind CSS.",
      liveLink: "https://freshcart-sigma-hazel.vercel.app/",
      githubLink: "https://github.com/Sakib8git/YOUR_REPO_NAME_HERE", // এখানে আপনার গিটহাব রিপোর সঠিক লিংকটি দিন
      challenges: [
        "Managing global cart state persistence across pages using React Context and LocalStorage in a Next.js Server-Side Rendering (SSR) environment",
        "Integrating Firebase Authentication securely with Next.js 16 Server Components to handle protected routes",
        "Ensuring a fully responsive grid layout for products using Tailwind CSS and ShadCN components",
      ],
      improvements: [
        "Integrate a real payment gateway (like Stripe or SSLCommerz) for transactions",
        "Build a dedicated Admin Dashboard to add/remove products and view orders",
        "Implement product search and filtering functionality based on categories",
        "Add a user profile section to view order history",
      ],
    },
    {
      id: 3,
      name: "Report-Hub",
      description:
        "Full-stack Modern Public Infrastructure Issue Reporting System ReportHub is a digital civic engagement platform designed to empower citizens to repor",
      image: "https://i.ibb.co.com/gZCs49DJ/Gemini-Generated-report.png",
      hoverColor: "accent",
      techStack: [
        "React.js",
        "TailwindCSS",
        "React Libraries",
        "TanStack Query (React Query)",
        "Node.js",
        "Express.js",
        "MongoDB",
        "JWT / Firebase Auth",
        "SweetAlert2",
        "Netlify ",
        "Vercel",
      ],

      briefDescription: (
        <>
          <p>
            ReportHub is a fullstack modern public infrastructure issue
            reporting system designed to empower citizens to report real-world
            problems such as broken streetlights, potholes, water leakage,
            garbage overflow, and damaged footpaths. It bridges the gap between
            citizens and municipal authorities by ensuring transparency, faster
            response times, and efficient service delivery.
          </p>
          <ul className="list-disc pl-5 mt-4 space-y-2 text-sm text-gray-300">
            <li>
              📝 <strong>Citizen Reporting:</strong> Submit issues with details,
              photos, and location.
            </li>
            <li>
              👨‍💼 <strong>Admin Management:</strong> Review, assign, and track
              issues.
            </li>
            <li>
              🛠️ <strong>Staff Workflow:</strong> Verify and update issue
              progress.
            </li>
            <li>
              🔄 <strong>Status Tracking:</strong> Issues move through stages:
              Pending → In-Progress → Resolved → Closed.
            </li>
            <li>
              📊 <strong>Analytics Dashboard:</strong> Track issue statistics
              and payments.
            </li>
            <li>
              🔔 <strong>Smart Notifications:</strong> SweetAlert2 / Toast
              notifications for login, signup, and all CRUD actions.
            </li>
            <li>
              ⭐ <strong>Premium Citizen Support:</strong> Priority handling for
              premium users.
            </li>
            <li>
              ⏱️ <strong>Real-Time Updates:</strong> Citizens can track their
              issue anytime.
            </li>
            <li>
              📈 <strong>Transparency & Efficiency:</strong> Reduced response
              time and better municipal service delivery.
            </li>
          </ul>
        </>
      ),
      liveLink: "https://project-report-hub.netlify.app",
      githubLink:
        "https://github.com/Sakib8git/Clint_Public_Issue_Reporting_System.git",
      challenges: [
        "Handling large datasets efficiently for real-time report generation",
        "Creating flexible report templates that work across different data types",
        "Implementing secure data sharing and permission management",
      ],
      improvements: [
        "Add AI-powered insights and recommendations",
        "Implement advanced data visualization options",
        "Create API for third-party integrations",
        "Add scheduled report delivery via email",
      ],
    },
    {
      id: 4,
      name: "Game-Hub",
      description:
        "GAME-HUB is a responsive React application that showcases a list of games with authentication, routing, and dynamic UI interactions.",
      image: "https://i.ibb.co.com/vxRtf3Sx/game.png",
      hoverColor: "green-500",
      techStack: [
        "React",
        "Firebase",
        "Node.js",
        "firebase",
        "Tailwind-css",
        "Framer Motion",
        "Material-UI",
      ],
      briefDescription: (
        <>
          <p>
            A gaming community platform where users can discover games, read
            reviews, create wishlists, connect with other gamers, and build
            social networking capabilities.
          </p>
          <ul className="list-disc pl-5 mt-4 space-y-2 text-sm text-gray-300">
            <li>
              🎨 <strong>Design:</strong> Gradient backgrounds, responsive
              layout, hover/tap animations
            </li>
            <li>
              🕹️ <strong>Game Pages:</strong> All Games, Popular Games, Game
              Details with ratings and download links
            </li>
            <li>
              🔐 <strong>Routing:</strong> Protected routes, redirect after
              login, dynamic detail pages
            </li>
            <li>
              🔑 <strong>Authentication:</strong> Email/password login, Google
              sign-in, password reset
            </li>
            <li>
              ✅ <strong>Validation:</strong> RegEx-based client-side form
              validation
            </li>
            <li>
              🎬 <strong>Animation:</strong> Framer Motion for hover, entry, and
              page transitions
            </li>
          </ul>
        </>
      ),
      liveLink: "https://game-hub-library.netlify.app",
      githubLink: "https://github.com/Sakib8git/Game-hub.git",
      challenges: [
        "Integrating multiple gaming APIs for comprehensive game data",
        "Creating responsive design that works well on gaming devices",
        "Implementing real-time chat and notification systems",
      ],
      improvements: [
        "Add game streaming integration",
        "Implement tournament organization features",
        "Create mobile app for on-the-go gaming community access",
        "Add AI-powered game recommendations",
      ],
    },
  ];

  const handleViewDetails = (project) => {
    setSelectedProject(project);
  };

  const closeModal = () => {
    setSelectedProject(null);
  };

  // Handle ESC key and click outside to close modal
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === "Escape" && selectedProject) {
        closeModal();
      }
    };

    if (selectedProject) {
      document.addEventListener("keydown", handleEscKey);
      document.body.style.overflow = "hidden"; // Prevent background scrolling
    }

    return () => {
      document.removeEventListener("keydown", handleEscKey);
      document.body.style.overflow = "unset";
    };
  }, [selectedProject]);

  return (
    <>
      <section
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full mt-32"
        id="work"
      >
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-3xl font-display font-bold text-white flex items-center gap-3">
              <span className="w-12 h-1 bg-primary rounded-full"></span>
              Selected Projects
            </h2>
            <p className="text-gray-400 mt-2">
              Highlights from my recent work.
            </p>
          </div>
          <div className="hidden sm:block h-px flex-1 bg-white/10 ml-8 mb-4"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project) => (
            <ProjectCard
              key={project.id}
              project={project}
              hoverColor={project.hoverColor}
              onViewDetails={handleViewDetails}
            />
          ))}
        </div>
      </section>

      {/* Project Detail Modal */}
      {selectedProject && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
          onClick={closeModal}
        >
          <div
            className="bg-[#0f1420] border border-white/10 rounded-3xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="sticky top-0 bg-[#0f1420] border-b border-white/10 p-6 flex items-center justify-between">
              <h2 className="text-2xl font-bold text-white">
                {selectedProject.name}
              </h2>
              <button
                onClick={closeModal}
                className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center text-gray-400 hover:text-white transition-colors"
              >
                <span className="material-symbols-outlined">close</span>
              </button>
            </div>

            <div className="p-6 space-y-8">
              {/* Project Image */}
              <div className="relative h-64 rounded-2xl overflow-hidden">
                <img
                  src={selectedProject.image}
                  alt={selectedProject.name}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Technology Stack */}
              <div>
                <h3 className="text-xl font-bold text-white mb-4">
                  Technology Stack
                </h3>
                <div className="flex flex-wrap gap-2">
                  {selectedProject.techStack.map((tech, index) => (
                    <span
                      key={index}
                      className="px-3 py-1 bg-primary/20 text-primary border border-primary/30 rounded-full text-sm font-medium"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>

              {/* Brief Description */}
              <div>
                <h3 className="text-xl font-bold text-white mb-4">
                  Description
                </h3>
                <p className="text-gray-300 leading-relaxed">
                  {selectedProject.briefDescription}
                </p>
              </div>

              {/* Links */}
              <div>
                <h3 className="text-xl font-bold text-white mb-4">Links</h3>
                <div className="flex flex-wrap gap-4">
                  <a
                    href={selectedProject.liveLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-6 py-3 bg-primary hover:bg-primary/90 text-white rounded-xl font-medium transition-colors flex items-center gap-2"
                  >
                    <span className="material-symbols-outlined text-[18px]">
                      launch
                    </span>
                    Live Project
                  </a>
                  <a
                    href={selectedProject.githubLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-6 py-3 bg-white/5 hover:bg-white/10 text-white border border-white/10 hover:border-white/20 rounded-xl font-medium transition-colors flex items-center gap-2"
                  >
                    <span className="material-symbols-outlined text-[18px]">
                      code
                    </span>
                    GitHub Repository
                  </a>
                </div>
              </div>

              {/* Challenges */}
              <div>
                <h3 className="text-xl font-bold text-white mb-4">
                  Challenges Faced
                </h3>
                <ul className="space-y-3">
                  {selectedProject.challenges.map((challenge, index) => (
                    <li
                      key={index}
                      className="flex items-start gap-3 text-gray-300"
                    >
                      <span className="w-2 h-2 bg-accent rounded-full mt-2 flex-shrink-0"></span>
                      <span>{challenge}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Future Improvements */}
              <div>
                <h3 className="text-xl font-bold text-white mb-4">
                  Future Improvements
                </h3>
                <ul className="space-y-3">
                  {selectedProject.improvements.map((improvement, index) => (
                    <li
                      key={index}
                      className="flex items-start gap-3 text-gray-300"
                    >
                      <span className="w-2 h-2 bg-green-500 rounded-full mt-2 flex-shrink-0"></span>
                      <span>{improvement}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProjectsSection;
